import { render, staticRenderFns } from "./GroupMembersWidget.vue?vue&type=template&id=df6d487c&scoped=true&"
import script from "./GroupMembersWidget.vue?vue&type=script&lang=js&"
export * from "./GroupMembersWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df6d487c",
  null
  
)

export default component.exports